{
  "COMPOSE_REDIRECT": {
    "OPENING": "{email} ile yeni bir görüşme açılıyor…",
    "NO_EMAIL": "E-posta adresi belirtilmedi. ?email=name@example.com kullanın",
    "CONTACT_ERROR": "{email} için kişi bulunamadı."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Lütfen sol bölmeden bir konuşma seçin",
    "CSAT_REPLY_MESSAGE": "Lütfen görüşmeyi değerlendirin",
    "404": "Maalesef konuşmayı bulamıyoruz. Lütfen tekrar deneyin",
    "SWITCH_VIEW_LAYOUT": "Düzeni değiştir",
    "DASHBOARD_APP_TAB_MESSAGES": "Mesajlar",
    "UNVERIFIED_SESSION": "Bu kullanıcının kimliği doğrulanmadı",
    "NO_MESSAGE_1": "Görünüşe göre gelen kutunuzda müşterilerden hiç mesaj yok.",
    "NO_MESSAGE_2": "sayfanıza bir mesaj göndermek için!",
    "NO_INBOX_1": "Görünüşe göre henüz gelen kutusu eklemediniz.",
    "NO_INBOX_2": "başlamak",
    "NO_INBOX_AGENT": "Görünüşe göre herhangi bir gelen kutusunun parçası değilsiniz. Lütfen yöneticinizle iletişime geçin",
    "SEARCH_MESSAGES": "Sohbetlerde ara",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Çeviri",
    "EMPTY_STATE": {
      "CMD_BAR": "komut menüsünü açmak için",
      "KEYBOARD_SHORTCUTS": "klavye kısayollarını görmek için"
    },
    "SEARCH": {
      "TITLE": "Mesajları ara",
      "RESULT_TITLE": "Arama Sonucu",
      "LOADING_MESSAGE": "Veriler işleniyor ...",
      "PLACEHOLDER": "Mesajları aramak için herhangi bir metin yazın",
      "NO_MATCHING_RESULTS": "Sonuç bulunamadı."
    },
    "UNREAD_MESSAGES": "Okunmamış Mesajlar",
    "UNREAD_MESSAGE": "Okunmamış Mesaj",
    "CLICK_HERE": "Buraya Tıkla",
    "LOADING_INBOXES": "Gelen kutuları yükleniyor",
    "LOADING_CONVERSATIONS": "Sohbetler Yükleniyor\n",
    "CANNOT_REPLY": "Nedeniyle cevap veremezsiniz",
    "24_HOURS_WINDOW": "24 saat mesaj penceresi kısıtlaması",
    "NOT_ASSIGNED_TO_YOU": "Bu görüşme size atanmamış. Bu konuşmayı kendinize atamak ister misiniz?",
    "ASSIGN_TO_ME": "Bana ata",
    "TWILIO_WHATSAPP_CAN_REPLY": "Bu konuşmaya yalnızca şablon mesaj kullanarak yanıt verebilirsiniz, çünkü",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 saat mesaj penceresi kısıtlaması",
    "REPLYING_TO": "Cevap veriyorsun:",
    "REMOVE_SELECTION": "Seçimi Kaldır",
    "DOWNLOAD": "İndir",
    "UNKNOWN_FILE_TYPE": "Bilinmeyen Dosya",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Göndermeden önce yapın:",
      "EXECUTE": "Yürüt",
      "RETRY": "Tekrar dene",
      "CONFIRM": "Şimdi yürütülsün mü?",
      "CONFIRM_YES": "Evet, yürüt",
      "CONFIRM_NO": "İptal",
      "RUNNING": "Yürütülüyor…",
      "DONE": "Tamamlandı",
      "CLAIM_DELAYED": "sipariş teslim edildiğinde oluşturulacak",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "YENİ bir şikayet kaydı {reference} oluşturuldu, {planned} kapalı — taslak metnini düzenleyin",
        "NEW_CLAIM": "{planned} güncellenmek yerine YENİ bir şikayet kaydı {reference} oluşturuldu — taslak metnini düzenleyin",
        "OTHER_CLAIM": "{planned} yerine {reference} şikayet kaydı güncellendi — taslak metnini düzenleyin",
        "EXISTING_CLAIM": "Yeni şikayet kaydı oluşturulmadı, mevcut {reference} güncellendi — taslak metnini düzenleyin",
        "OTHER": "İşlem taslağın varsaydığından farklı sonuçlandı — taslak metnini düzenleyin"
      },
      "FAILED": "Başarısız",
      "UNREACHABLE": "Bota ulaşılamadı",
      "REQUEST_FAILED": "İşlem başlatılamadı, lütfen tekrar deneyin.",
      "ACTIONS": {
        "CANCEL_ORDER": "Siparişi iptal edin",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Ödeme yöntemini kapıda ödeme olarak değiştirin",
        "CREATE_CLAIM": "Şikayet kaydı oluşturun",
        "CREATE_OR_UPDATE_CLAIM": "Şikayet kaydı oluşturun veya güncelleyin",
        "EXTEND_ORDER_PICKUP_DATE": "Teslim alma süresini uzatın"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Dosyalar gönderiliyor...",
    "REPLIED_TO_STORY": "Hikayene cevap verildi",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Bu mesaj desteklenmiyor. Bu mesajı Facebook Messenger uygulamasında görüntüleyebilirsiniz.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Bu mesaj desteklenmiyor. Bu mesajı Instagram uygulamasında görüntüleyebilirsiniz.",
    "SUCCESS_DELETE_MESSAGE": "Mesaj başarıyla silindi",
    "FAIL_DELETE_MESSSAGE": "Mesaj silinemiyor. Tekrar deneyin",
    "NO_RESPONSE": "Cevap Yok",
    "RESPONSE": "Response",
    "RATING_TITLE": "Değerlendirme",
    "FEEDBACK_TITLE": "Geribildirim",
    "REPLY_MESSAGE_NOT_FOUND": "Mesaj bulunamadı",
    "CARD": {
      "SHOW_LABELS": "Etiketleri Göster",
      "HIDE_LABELS": "Etiketleri Gizle"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Çözüldü",
      "REOPEN_ACTION": "Yeniden aç",
      "OPEN_ACTION": "Açık",
      "OPEN": "Devamı",
      "CLOSE": "Kapat",
      "DETAILS": "detaylar",
      "SNOOZED_UNTIL": "Susturulacak kadar ertelendi",
      "SNOOZED_UNTIL_TOMORROW": "yarına ertelendi",
      "SNOOZED_UNTIL_NEXT_WEEK": "Önümüzdeki haftaya ertelendi",
      "SNOOZED_UNTIL_NEXT_REPLY": "Bir sonraki yanıta kadar ertelendi",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Beklemede olarak işaretle",
      "SNOOZE_UNTIL": "Sustur",
      "SNOOZE": {
        "TITLE": "Şu tarihe kadar ertele",
        "NEXT_REPLY": "Sonraki yanıt",
        "TOMORROW": "Yarın",
        "NEXT_WEEK": "Sonraki hafta"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Şu tarihe kadar ertele",
      "APPLY": "Sustur",
      "CANCEL": "İptal Et"
    },
    "PRIORITY": {
      "TITLE": "Öncelik",
      "OPTIONS": {
        "NONE": "Hiçbiri",
        "URGENT": "Acil",
        "HIGH": "Yüksek",
        "MEDIUM": "Orta",
        "LOW": "Düşük"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Hiçbiri",
        "INPUT_PLACEHOLDER": "Öncelik seçin",
        "NO_RESULTS": "Sonuç bulunamadı",
        "SUCCESSFUL": "Sohbet kimliği {conversationId} önceliği {priority} olarak değiştirildi",
        "FAILED": "Öncelik değiştirilemedi. Lütfen tekrar deneyin."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Yeni sekmede aç",
      "COPY_LINK": "Konuşma bağlantısını kopyala",
      "COPY_LINK_SUCCESS": "Konuşma bağlantısı panoya kopyalandı",
      "PENDING": "Beklemede olarak işaretle",
      "RESOLVED": "Çözüldü olarak işaretle",
      "MARK_AS_UNREAD": "Okunmamış olarak işaretle",
      "MARK_AS_READ": "Okundu olarak işaretle",
      "REOPEN": "Görüşmeyi yeniden açın",
      "SNOOZE": {
        "TITLE": "Sustur",
        "NEXT_REPLY": "Sonraki yanıta kadar",
        "TOMORROW": "Yarına kadar",
        "NEXT_WEEK": "Gelecek haftaya kadar"
      },
      "ASSIGN_AGENT": "Temsilci ata",
      "ASSIGN_LABEL": "Etiket ata",
      "AGENTS_LOADING": "Temsilciler Yükleniyor...",
      "ASSIGN_TEAM": "Takım ata",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Sohbet kimliği {conversationId} \"{agentName}\" tarafından atanmış",
          "FAILED": "Temsilci atanamadı. Lütfen tekrar deneyin."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Etiket atanamadı. Lütfen tekrar deneyin."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Sohbet kimliği {conversationId} için \"{team}\" takımına atanmış",
          "FAILED": "Takım atanamadı. Lütfen tekrar deneyin."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "İmzanız",
      "ENABLE_SIGN_TOOLTIP": "İmzayı etkinleştir",
      "DISABLE_SIGN_TOOLTIP": "İmzayı devre dışı bırak",
      "MSG_INPUT": "Yeni satır için Shift + enter. Bir Hazır Yanıt seçmek için \"/\" ile başlayın.",
      "PRIVATE_MSG_INPUT": "Yeni satır için Shift + enter. Bu yalnızca Temsilciler tarafından görülebilir",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Mesaj imzası yapılandırılmamış, lütfen profil ayarlarında yapılandırın.",
      "CLICK_HERE": "Güncellemek için tıklayın",
      "WHATSAPP_TEMPLATES": "WhatsApp Şablonları",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24 saatlik WhatsApp penceresi sona erdi. Şablon mesajla yanıt verin.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Yanıtınız {draftLanguage} dilinde görünüyor, ancak bu görüşme {conversationLanguage} dilinde.",
      "TRANSLATE_DRAFT": "Çevir",
      "REPLY": "Cevapla",
      "PRIVATE_NOTE": "Özel Not",
      "SEND": "Gönder",
      "CREATE": "Not ekle",
      "INSERT_READ_MORE": "Daha fazla oku",
      "DISMISS_REPLY": "Cevabı reddet",
      "REPLYING_TO": "Cevap veriliyor:",
      "TIP_FORMAT_ICON": "Metin Düzenlemeyi Göster",
      "HEADING_LEVEL": {
        "LABEL": "Metin stili",
        "NORMAL": "Normal metin",
        "H1": "Başlık 1",
        "H2": "Başlık 2",
        "H3": "Başlık 3"
      },
      "EDITOR": {
        "BOLD": "Kalın",
        "ITALIC": "İtalik",
        "UNDERLINE": "Altı çizili",
        "TEXT_COLOR": "Metin rengi",
        "BG_COLOR_LABEL": "Arka plan rengi",
        "FONT_SIZE_LABEL": "Yazı boyutu",
        "FONT_SIZE": {
          "XS": "Küçük",
          "SM": "Orta küçük",
          "MD": "Varsayılan",
          "LG": "Büyük",
          "XL": "Çok büyük",
          "XXL": "Devasa"
        },
        "CODE": "Kod",
        "LINK": "Bağlantı ekle veya kaldır",
        "CREATE_LINK": "Bağlantı oluştur",
        "SAVE_LINK": "Kaydet",
        "CANCEL": "İptal",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Geri al",
        "REDO": "Yinele",
        "BULLET_LIST": "Madde işaretli liste",
        "ORDERED_LIST": "Numaralı liste",
        "BLOCKQUOTE": "Alıntı",
        "H1": "Başlık 1",
        "H2": "Başlık 2",
        "H3": "Başlık 3",
        "IMAGE_UPLOAD": "Resim yükle",
        "CLEAR_FORMATTING": "Biçimlendirmeyi temizle",
        "COLOR": {
          "RED": "Kırmızı",
          "YELLOW": "Sarı",
          "BLUE": "Mavi",
          "ROSE_RED": "Gül kırmızısı",
          "DEEP_CYAN": "Koyu camgöbeği",
          "ORANGE": "Turuncu",
          "PISTACHIO": "Fıstık yeşili",
          "PURPLE": "Mor",
          "FUCHSIA": "Fuşya",
          "SILVER": "Gümüş",
          "NAVY": "Lacivert",
          "OLD_PINK": "Eski gül",
          "AQUA": "Turkuaz",
          "BROWN": "Kahverengi",
          "OLIVE": "Zeytin yeşili",
          "GOLD": "Altın",
          "BEIGE": "Bej",
          "WINE": "Şarap rengi",
          "FOREST": "Orman yeşili",
          "GREEN": "Yeşil",
          "BLUE_GREY": "Mavi gri",
          "RUBY_RED": "Yakut kırmızısı",
          "CHESTNUT_BROWN": "Kestane kahverengisi",
          "ASH_GREY": "Kül grisi"
        },
        "BG_COLOR": {
          "RED": "Kırmızı",
          "YELLOW": "Sarı",
          "BLUE": "Mavi",
          "ROSE_RED": "Gül kırmızısı",
          "DEEP_CYAN": "Koyu camgöbeği",
          "ORANGE": "Turuncu",
          "PISTACHIO": "Fıstık yeşili",
          "PURPLE": "Mor",
          "FUCHSIA": "Fuşya",
          "SILVER": "Gümüş",
          "NAVY": "Lacivert",
          "OLD_PINK": "Eski gül",
          "AQUA": "Turkuaz",
          "BROWN": "Kahverengi",
          "OLIVE": "Zeytin yeşili",
          "GOLD": "Altın",
          "BEIGE": "Bej",
          "WINE": "Şarap rengi",
          "FOREST": "Orman yeşili",
          "GREEN": "Yeşil",
          "BLUE_GREY": "Mavi gri",
          "RUBY_RED": "Yakut kırmızısı",
          "CHESTNUT_BROWN": "Kestane kahverengisi",
          "ASH_GREY": "Kül grisi"
        }
      },
      "TIP_EMOJI_ICON": "Emojileri göster",
      "TIP_ATTACH_ICON": "Dosya ekle",
      "TIP_AUDIORECORDER_ICON": "Ses kaydet",
      "TIP_AUDIORECORDER_PERMISSION": "Mikrofon erişimine izin ver",
      "TIP_AUDIORECORDER_ERROR": "Mikrofon açılamadı",
      "DRAG_DROP": "Eklemek için buraya sürükleyip bırakın",
      "START_AUDIO_RECORDING": "Ses kaydına başla",
      "STOP_AUDIO_RECORDING": "Ses kaydını durdur",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Bcc ekle",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Virgülle ayrılmış e-postalar",
          "ERROR": "Lütfen geçerli bir e-posta adresi girin"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Virgülle ayrılmış e-postalar",
          "ERROR": "Lütfen geçerli bir e-posta adresi girin"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Tanımsız değişkenler",
        "MESSAGE": "Mesajınızda {undefinedVariablesCount} tanımsız değişken bulunmaktadır: {undefinedVariables}. Yine de mesajı göndermek ister misiniz?",
        "CONFIRM": {
          "YES": "Gönder",
          "CANCEL": "İptal Et"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "SMS yanıtı gönderebilmek için bir SMS gelen kutusu ekleyin.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Özel Not: Yalnızca siz ve ekibiniz tarafından görülebilir",
    "CHANGE_STATUS": "Görüşme durumu değişti",
    "CHANGE_STATUS_FAILED": "Sohbet durumu değiştirilemedi",
    "CHANGE_AGENT": "Atanan kişiyi değiştirildi",
    "CHANGE_AGENT_FAILED": "Atanan kişi değiştirilemedi",
    "ASSIGN_LABEL_SUCCESFUL": "Etiket başarıyla atandı",
    "ASSIGN_LABEL_FAILED": "Etiket ataması yapılamadı",
    "CHANGE_TEAM": "Takım değişti",
    "FILE_SIZE_LIMIT": "Dosya, {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB ek dosya sınırını aşıyor",
    "MESSAGE_ERROR": "Bu mesaj gönderilemiyor, lütfen daha sonra tekrar deneyin",
    "SENT_BY": "Tarafından gönderildi:",
    "BOT": "Bot",
    "SEND_FAILED": "Mesaj gönderilemedi! Tekrar deneyin",
    "TRY_AGAIN": "tekrar dene",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Temsilci Seçin",
      "REMOVE": "Kaldır",
      "ASSIGN": "Atama yap"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopyala",
      "REPLY_TO": "Bu mesaja yanıtla",
      "DELETE": "Sil",
      "CREATE_A_CANNED_RESPONSE": "Hızlı cevaplara ekle",
      "TRANSLATE": "Çevir",
      "COPY_PERMALINK": "Mesajın bağlantısını kopyala",
      "LINK_COPIED": "Mesaj URL'si panoya kopyalandı",
      "DELETE_CONFIRMATION": {
        "TITLE": "Bu mesajı silmek istediğinizden emin misiniz?",
        "MESSAGE": "Bu eylemi geri alamazsınız",
        "DELETE": "Sil",
        "CANCEL": "İptal Et"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "İletişim",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Konuşma {userName} tarafından çözümlendi olarak işaretlendi",
          "CONTACT_RESOLVED": "Konuşma {contactName} tarafından çözümlendi olarak işaretlendi",
          "OPEN": "Konuşma {userName} tarafından açık olarak işaretlendi",
          "PENDING": "Konuşma, {userName} tarafından bekleyen olarak işaretlendi",
          "SNOOZED": "Konuşma, {userName} tarafından erteledi olarak işaretlendi",
          "AUTO_RESOLVED": " {duration} günlük hareketsizlik nedeniyle konuşma, sistem tarafından çözümlendi olarak işaretlendi",
          "SYSTEM_AUTO_OPEN": "Sistem, yeni gelen bir mesaj nedeniyle konuşmayı tekrar açtı.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Ticket Kaufland'da kapatıldığı için konuşma, sistem tarafından çözümlendi olarak işaretlendi."
        },
        "PRIORITY": {
          "ADDED": "{userName} önceliği {newPriority} olarak ayarladı",
          "UPDATED": "{userName} önceliği {oldPriority} dan {newPriority} olarak değiştirdi",
          "REMOVED": "{userName} önceliği kaldırdı"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} bu konuşmayı kendisine atadı",
          "ASSIGNED": "{userName} tarafından {assigneeName} adına atandı",
          "REMOVED": "{userName} tarafından konuşmanın atanması kaldırıldı"
        },
        "TEAM": {
          "ASSIGNED": "{userName} tarafından {teamName} adına atandı",
          "ASSIGNED_WITH_ASSIGNEE": "{userName} tarafından {teamName} aracılığıyla {assigneeName} adına atandı",
          "REMOVED": "{userName} tarafından {teamName} ataması kaldırıldı"
        },
        "LABELS": {
          "ADDED": "{userName}, {labels} ekledi",
          "REMOVED": "{userName}, {labels} kaldırdı"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName}, sohbeti sessize aldı",
        "UNMUTED": "{userName} konuşmanın sesini açtı",
        "CONTACT_BLOCKED": "{userName} kişiyi engelledi",
        "CONTACT_UNBLOCKED": "{userName} kişinin engelini kaldırdı",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Kişinin siparişleri yalnızca {storeName} mağazasından geldiği için taşındı (son sipariş {orderId}); bu mağazanın robotu bu gelen kutusunda yanıt veriyor.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Kişi engellendiği için otomasyon atlandı",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "\"{ruleName}\" otomasyonu, gelen kutuları uyumlu olmadığı için bu konuşmayı {sourceInboxName} gelen kutusundan {targetInboxName} gelen kutusuna taşıyamadı.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "\"{ruleName}\" otomasyonu, kişinin e-posta adresi olmadığı için bu konuşmayı {sourceInboxName} gelen kutusundan {targetInboxName} gelen kutusuna taşıyamadı.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "\"{ruleName}\" otomasyonu mesaj gönderemedi: hesapta SMS gelen kutusu olmadığı için bu telefon gelen kutusu SMS gönderemez. Kural kapatıldı ve yöneticilere e-posta gönderildi.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "\"{ruleName}\" otomasyonu mesaj gönderemedi: bu gelen kutusundan SMS ile ek gönderilemez. Kural kapatıldı ve yöneticilere e-posta gönderildi.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "\"{macroName}\" kısayolu mesajını göndermedi: hesapta SMS gelen kutusu olmadığı için bu telefon gelen kutusu SMS gönderemez.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "\"{macroName}\" kısayolu mesajını göndermedi: bu gelen kutusundan SMS ile ek gönderilemez.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "\"{macroName}\" kısayolu mesajını göndermedi: bu sohbeti bot yönetiyor. Önce sohbeti açın.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "\"{macroName}\" kısayolu mesajını göndermedi: bu gelen kutusu silinmek üzere işaretlendi. Önce sohbeti başka bir gelen kutusuna taşıyın.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "\"{ruleName}\" otomasyonu, {inboxName} gelen kutusundaki yeni [#{conversationId}]({conversationPath}) konuşmasında {contactEmail} adresine e-posta gönderdi.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "\"{ruleName}\" otomasyonu bu konuşmayı {inboxName} gelen kutusundaki [#{conversationId}]({conversationPath}) konuşması nedeniyle başlattı.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "\"{ruleName}\" otomasyonu, kişinin e-posta adresi olmadığı için mesajı {inboxName} gelen kutusunda yeni bir konuşmada gönderemedi.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "\"{ruleName}\" otomasyonu, {inboxName} gelen kutusundaki yeni [#{conversationId}]({conversationPath}) konuşmasında {contactPhone} numarasına SMS gönderdi.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "\"{ruleName}\" otomasyonu, kişinin telefon numarası olmadığı için SMS'i {inboxName} gelen kutusunda yeni bir konuşmada gönderemedi.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Temsilci",
            "CUSTOMER": "Müşteri"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "başka yerde cevaplandı, {duration} çaldı",
            "NO_ANSWER": "cevaplanmadı, {duration} çaldı",
            "REJECTED": "reddedildi, {duration} çaldıktan sonra"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Başarısız geri arama sayısı {count} olduğu için otomatik olarak çözümlendi",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Arama kaydı {name} tarafından silindi, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Müşteriye görünmez",
    "SENT_VIA_EMAIL": "Kişiye e-posta ile de gönderildi ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Bu gelen kutusu silinmek üzere işaretlendi, bu yüzden müşterinin yanıtı asla ulaşmaz. Yanıtlamak için sohbeti başka bir gelen kutusuna taşıyın.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Bu kişinin başka bir açık konuşması var #{id}",
      "MULTIPLE": "Bu kişinin başka açık konuşmaları var ({count})",
      "OPEN": "Aç",
      "SHOW": "Göster"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Müşteriden WhatsApp telefon numarasını paylaşmasını iste",
      "PENDING_ACTION": "İletişim bilgisi talebi beklemede",
      "STATES": {
        "PENDING": "İletişim bilgisi bekleniyor",
        "SHARED": "Telefon numarası paylaşıldı",
        "IDENTITY_CONFLICT": "Telefon numarası incelenmeli"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "E-posta İletişim Kaydını Gönder",
    "DESC": "Belirtilen e-posta adresine konuşma dökümünün bir kopyasını gönderin",
    "SUBMIT": "Gönder",
    "CANCEL": "İptal Et",
    "SEND_EMAIL_SUCCESS": "İletişim kaydı başarıyla gönderildi",
    "SEND_EMAIL_ERROR": "Bir hata oluştu, lütfen tekrar deneyin",
    "FORM": {
      "SEND_TO_CONTACT": "İletişim kaydını müşteriye gönder",
      "SEND_TO_AGENT": "Atanan temsilciye iletişim kaydını gönder",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "İletişim kaydını başka bir e-posta adresine gönder",
      "EMAIL": {
        "PLACEHOLDER": "Bir e-posta adresi girin",
        "ERROR": "Lütfen geçerli bir e-posta adresi girin"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Merhaba 👋, {installationName}'a hoş geldiniz!",
    "DESCRIPTION": "Üyeliğiniz için teşekkür ederiz. {installationName}'dan en iyi şekilde faydalanmanızı istiyoruz. Deneyimi daha keyifli hale getirmek için {installationName} içinde yapabileceğiniz birkaç şey var.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "En Son Güncellemeleri Okuyun",
    "ALL_CONVERSATION": {
      "TITLE": "Tüm Konuşmalarınız Bir Arada",
      "DESCRIPTION": "Müşterilerinizden gelen tüm konuşmaları tek bir gösterge panelinde görüntüleyin. Gelen kanala, etikete ve duruma göre konuşmaları filtreleyebilirsiniz.",
      "NEW_LINK": "Bir gelen kutusu oluşturmak için buraya tıklayın"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Ekip Üyelerinizi Davet Edin",
      "DESCRIPTION": "Müşterinizle konuşmaya hazırlanırken, ekibinizi yardıma çağırın. Ekibinizi, temsilci listesine e-posta adreslerini ekleyerek davet edebilirsiniz.",
      "NEW_LINK": "Bir ekip üyesi davet etmek için buraya tıklayın"
    },
    "LABELS": {
      "TITLE": "Etiketlerle Konuşmaları Düzenleyin",
      "DESCRIPTION": "Etiketler, konuşmalarınızı kategorize etmenin daha kolay bir yolunu sağlar. #destek-soru, #fatura-sorunu vb. gibi etiketler oluşturun, böylece daha sonra bir konuşmada bunları kullanabilirsiniz.",
      "NEW_LINK": "Etiket oluşturmak için buraya tıklayın"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Atanan Temsilci",
    "SELF_ASSIGN": "Bana Ata",
    "TEAM_LABEL": "Atanan Takım",
    "SELECT": {
      "PLACEHOLDER": "Hiç"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "İletişim Detayları",
      "CONVERSATION_ACTIONS": "Konuşma Eylemleri",
      "CONVERSATION_LABELS": "Konuşma Etiketleri",
      "CONVERSATION_INFO": "Konuşma Bilgisi",
      "CONTACT_ATTRIBUTES": "İletişim Nitelikleri",
      "PREVIOUS_CONVERSATION": "Önceki Konuşmalar",
      "MACROS": "Kısayollar",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Bekliyor",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Nitelik Oluştur",
    "NO_RECORDS_FOUND": "Nitelik bulunamadı",
    "UPDATE": {
      "SUCCESS": "Öznitelik başarıyla güncellendi",
      "ERROR": "Öznitelik güncellenemedi. Lütfen daha sonra tekrar deneyiniz"
    },
    "ADD": {
      "TITLE": "Ekle",
      "SUCCESS": "Öznitelik başarıyla eklendi",
      "ERROR": "Öznitelik eklenemedi. Lütfen daha sonra tekrar deneyiniz"
    },
    "DELETE": {
      "SUCCESS": "Öznitelik başarıyla silindi",
      "ERROR": "Öznitelik silinemedi. Lütfen daha sonra tekrar deneyiniz"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Özellik Ekle",
      "PLACEHOLDER": "Öznitelik ara",
      "NO_RESULT": "Öznitelik bulunamadı"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Kimden",
    "TO": "Kime",
    "BCC": "Gizli Kopya",
    "CC": "Kopya",
    "SUBJECT": "Konu"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Katılımcılar",
    "SIDEBAR_TITLE": "Konuşma Katılımcıları",
    "NO_RECORDS_FOUND": "Kayıt bulunamadı",
    "ADD_PARTICIPANTS": "Katılımcıları Seç",
    "REMANING_PARTICIPANTS_TEXT": "+{count} diğer",
    "REMANING_PARTICIPANT_TEXT": "+{count} diğer",
    "TOTAL_PARTICIPANTS_TEXT": "{count} kişi katılıyor.",
    "TOTAL_PARTICIPANT_TEXT": "{count} kişi katılıyor.",
    "NO_PARTICIPANTS_TEXT": "Kimse katılmıyor!",
    "WATCH_CONVERSATION": "Konuşmaya Katıl",
    "YOU_ARE_WATCHING": "Katılıyorsunuz",
    "API": {
      "ERROR_MESSAGE": "Güncellenemedi, tekrar deneyin!",
      "SUCCESS_MESSAGE": "Katılımcılar güncellendi!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Çevrili İçeriği Görüntüle",
    "DESC": "İçeriği her dilde çevrilen şekilde görüntüleyebilirsiniz.",
    "ORIGINAL_CONTENT": "Orijinal İçerik",
    "TRANSLATED_CONTENT": "Çevrilen İçerik",
    "NO_TRANSLATIONS_AVAILABLE": "Bu için çeviri mevcut değil"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Sipariş numarası",
    "EXTERNAL_ID": "Harici ID",
    "PAYMENT_TYPE": "Ödeme yöntemi",
    "PAYMENT_DATE": "Ödeme tarihi",
    "DELIVERY_PROVIDER": "Kargo firması",
    "EXPECTED_DATE_OF_DELIVERY": "Beklenen teslimat",
    "DATE_OF_DELIVERY": "Teslim edildi",
    "EXPEDITION_DATE": "Gönderim tarihi",
    "INTERNAL_NOTE": "Mağaza notu",
    "PACKAGE_NUMBER": "Gönderi"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
